module.exports = __webpack_public_path__ + "static/whiz-logo-101d40689f540366d5b2e87c9442476f.jpg";